import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router';
import styles from './App.css';
import PreviewPage from '../../pages/Preview/PreviewPage';
import ViewPage from '../../pages/View/ViewPage';
import CreatePage from '../../pages/Create/CreatePage';
import {
  PATH_CREATE_FORM,
  PATH_VIEW_FORM,
  PATH_PREVIEW_FORM,
  PATH_CONTRIBUTE_FORM,
  PATH_CERTIFICATION_FORM,
  PATH_CONTRIBUTE_MARK,
  PATH_CONTRIBUTE_VIEW_FORM,
  PATH_CONTRIBUTE_TASKLINE_ANSWER,
  PATH_CERTIFICATION_PUBLISH_QUESTION,
  PATH_CERTIFICATION_VIEW,
  PATH_CONTRIBUTE_REVIEW_FORM,
  PATHS_WITH_DRAWER,
  PATHS_WITH_INFO,
} from '../../../constants/paths';
import AppDrawer from './Drawer/AppDrawer';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import InfoButton from '../../molecules/Info/InfoButton';
import InfoPage from '../../pages/Info/InfoPage';
import ContributePage from '../../pages/Contribute/ContributePage';
import CertificationPage from '../../pages/Certification/CertificationPage';
import ContributeAnwserPage from '../../pages/Contribute/ContributeAnwserPage';
import * as config from '../../../helpers/config';
import WYSIWYGGridPage from '../../pages/WYSIWYGGrid/WYSIWYGGridPage';
import { ToastContainer } from 'react-toastify';
import ShortcutKeyboard from '../../atoms/ShortcutKeyboard/ShortcutKeyboard.jsx';
import AlertProvider from '../../molecules/Alert/AlertContext';
import cssvars from '../../../styles/variables';
import { LastLocationProvider } from '../../../hooks/useLastLocation';

const App = () => (
  <DndProvider backend={HTML5Backend}>
    <AlertProvider>
      <Router basename={config.get('basename')}>
        <LastLocationProvider>
          <div className={styles.App} style={{ '--font-size-input': cssvars['font-size-input'] }}>
            <Routes>
              {PATHS_WITH_DRAWER.map((drawerRoutePath) => (
                <Route
                  key={drawerRoutePath}
                  path={drawerRoutePath}
                  element={<AppDrawer path={drawerRoutePath} />}
                />
              ))}
              {/* No drawer on the other paths */}
              <Route path="*" element={null} />
            </Routes>
            <main id="app-main" className={styles.App__main}>
              <Routes>
                <Route path={PATH_VIEW_FORM} element={<ViewPage />} />
                <Route path={PATH_PREVIEW_FORM} element={<PreviewPage />} />
                {PATHS_WITH_DRAWER.map((drawerRoutePath) => (
                  <Route
                    key={drawerRoutePath}
                    path={drawerRoutePath}
                    element={<WYSIWYGGridPage path={drawerRoutePath} />}
                  />
                ))}
                <Route path={PATH_CREATE_FORM} element={<CreatePage />} />
                <Route path={PATH_CONTRIBUTE_FORM} element={<ContributePage />} />
                <Route
                  path={PATH_CONTRIBUTE_VIEW_FORM}
                  element={<ContributeAnwserPage answerOf="task" />}
                />
                {/* v3 only, details in paths.js */}
                <Route
                  path={PATH_CONTRIBUTE_MARK}
                  element={<ContributeAnwserPage answerOf="task" withMarking />}
                />
                {/* v5 only, details in paths.js */}
                <Route
                  path={PATH_CONTRIBUTE_TASKLINE_ANSWER}
                  element={<ContributeAnwserPage answerOf="taskLine" />}
                />
                <Route path={PATH_CONTRIBUTE_REVIEW_FORM} element={<ContributePage isReview />} />
                <Route
                  path={PATH_CERTIFICATION_FORM}
                  element={<CertificationPage mode="answering" />}
                />
                {/* v5 only, details in paths.js */}
                <Route
                  path={PATH_CERTIFICATION_PUBLISH_QUESTION}
                  element={<CertificationPage mode="publishing" />}
                />
                {/* v5 only, details in paths.js */}
                <Route
                  path={PATH_CERTIFICATION_VIEW}
                  element={<ContributeAnwserPage answerOf="certification" />}
                />

                {/* TODO: better not found */}
                <Route path="*" element={<>not found</>} />
              </Routes>
            </main>
            <Routes>
              {PATHS_WITH_INFO.map((infoRoutePath) => (
                <Route
                  key={infoRoutePath}
                  path={infoRoutePath}
                  element={
                    <>
                      <InfoPage path={infoRoutePath} />
                      <InfoButton />
                    </>
                  }
                />
              ))}
              {/* No information panel on the other paths */}
              <Route path="*" element={null} />
            </Routes>
          </div>
        </LastLocationProvider>
      </Router>
      <ToastContainer
        autoClose={6000}
        position={'top-right'}
        hideProgressBar
        pauseOnHover={false}
      />
      <ShortcutKeyboard />
    </AlertProvider>
  </DndProvider>
);

export default App;
